import { useEffect, useState } from 'react';

/**
 * Bu sürenin altındaki sayımlarda rakam gösterilmiyor.
 *
 * Bot düşünme süresi ~800 ms; oraya rakam koymak "1" yazıp kaybolan bir
 * titreme yaratıyordu. Halka yine dönüyor — masanın canlı olduğu görülüyor,
 * ama sayı okunmaya çalışılmıyor.
 */
export const TIMER_TEXT_MIN_MS = 4000;

const R = 21;
const C = 2 * Math.PI * R;

export function TimerRing({ deadline, total }: { deadline: number | null; total: number }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    // 10 Hz yeterli: halka gözle sürekli akıyor, animasyon karesi harcamıyor.
    const id = setInterval(() => setNow(Date.now()), 100);
    return () => clearInterval(id);
  }, []);

  if (deadline === null || total <= 0) return null;

  const left = Math.max(0, deadline - now);
  const ratio = Math.min(1, left / total);
  const seconds = Math.ceil(left / 1000);
  const urgent = left <= 5000 && total >= TIMER_TEXT_MIN_MS;

  return (
    <svg className={`ring ${urgent ? 'ring--urgent' : ''}`} viewBox="0 0 48 48" aria-hidden>
      <circle className="ring__track" cx="24" cy="24" r={R} />
      <circle
        className="ring__fill"
        cx="24"
        cy="24"
        r={R}
        strokeDasharray={C}
        strokeDashoffset={C * (1 - ratio)}
      />
      {total >= TIMER_TEXT_MIN_MS && (
        <text className="ring__text" x="24" y="24">
          {seconds}
        </text>
      )}
    </svg>
  );
}
